// plugins/vuetify.js
import Vue from 'vue';
import '@nuskin/design-components';

/**
 * Inject vuetify so we can use it in other middleware/handlers
 * @param {*} _ don't care about this parameter
 * @param {*} inject used for injection
 */
export default function(_, inject) {
    // make `$vuetify` available in Nuxt context
    inject('vuetify', Vue.prototype.$vuetify);
}
